<script lang="ts">
  import { faChartLine, faForward } from "@fortawesome/free-solid-svg-icons";
  import Fa from "svelte-fa";
  import { Button,Col,Modal,ModalBody,Row } from "sveltestrap";
import Game from "../pages/Game.svelte";
  import { gamestate } from "../stores";
  import Headline from "./Headline.svelte";
import StarRating from "./StarRating.svelte";

  export let isOpen: boolean;
  export let toggle: () => void;

  let headlinesSorted = [];
  $: headlinesSorted = $gamestate.activeHeadlines.sort((a, b) => (b.views.latestChange || 0) - (a.views.latestChange || 0));
</script>

<Modal size="xl" {isOpen} {toggle}>
  <h2 class="modal-header d-flex bg-black text-light">
    Day {$gamestate.turn + 1} Summary
    <span class="flex-grow-1"></span>
    <Button
      class="sans"
      color="light"
      on:click={() => {
        toggle();
      }}
    >
      Next Day <Fa icon={faForward}/>
    </Button>
  </h2>

  <ModalBody>
    <Row>
      <Col md="3" sm="12">
        <h3 class="sans">Today's Profit</h3>
        <span class="display-4">${$gamestate.money.latestChange.toFixed(2)}</span>

        <h3 class="sans mt-3">New Subscribers</h3>
        <span class="display-4">{$gamestate.subscribers.length - $gamestate.lastTurnSubscribers}</span>

        {#if $gamestate.rating != $gamestate.lastTurnRating}
          <h3 class="sans mt-3">New Rating!</h3>
          <span class="display-6 mt-3">
            <StarRating stars={$gamestate.rating} />
          </span>
        {/if}
      </Col>

      <Col md="9" sm="12">
        <h3 class="sans">Top Headlines</h3>
        {#each headlinesSorted.slice(0, 4) as headline}
          <Headline {headline}/>
        {/each}
        {#if !headlinesSorted.length}
          <span class="opacity-75">Nothing published yet!</span>
        {/if}
      </Col>
    </Row>
  </ModalBody>
</Modal>